"use client"
export default function Error({ reset }: { reset: () => void }) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center">
      <h1 className="text-3xl font-bold mb-4">500 – Vidinė serverio klaida</h1>
      <p className="text-lg text-gray-600 mb-4">Įvyko netikėta klaida. Bandykite dar kartą.</p>
      <button
        className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
        onClick={() => reset()}
      >
        Bandykite iš naujo
      </button>
    </div>
  );
}
